import React, {useContext, useState} from "react";
import {createUseStyles, useTheme} from "react-jss";
import VirtualHost, {MobileVirtualHost} from "../common/VirtualHost";
import Question from "../question/Question";
import {Theme} from "engage-client/theme";
import {EngageAppContext} from "../../App";
import {TriviaStatus} from "../../state/state";
import HostDashboard from "../dashboard/HostDashboard";
import useMediaQuery from "engage-client/hooks/useMediaQuery";
import {InputType} from "../../state/questions";
import AccessoryPanel from "../accessory/AccessoryPanel";
import {ExpansionTimeMS, PanelState} from "../accessory/accessoryConstants";
import {Role} from "engage-common/types";

//TODO:Need to figure out how to do multiple computed properties within one class
// @ts-ignore
const useStyles = createUseStyles<Theme>((theme) => ({
    inProgress: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    bottomContainer: {
        position: "relative",
        flex: 1,
        display: "flex"
    },
    questionContainer: {
        flex: 1,
        [theme.breakpoints.up("lg")]: {
            paddingRight:20,
            display: "flex",
            justifyContent: props => props.questionJustify,
            paddingTop:50,
        },
        [theme.breakpoints.up("xl")]: {
            paddingRight: 30,
        },
        [theme.breakpoints.down("md")]: {
            paddingBottom:30,
        },
        [theme.breakpoints.up("xxl")] : {
            paddingTop: "4vh"
        }
    },
    virtualHostContainer: {
        paddingTop: 50,
        display: "flex",
        [theme.breakpoints.up("xxl")] : {
            paddingTop: "4vh"
        }
    },
    gameCompleteContainer: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        [theme.breakpoints.down("md")]: {
            paddingTop: 75
        }
    },

 
    overlay: {
        position: "absolute",
        top: 0,
        left:0,
        right:0,
        bottom:0,
        opacity: ({panelState:ps}) => ps === PanelState.expanded || ps === PanelState.expanding ? 0.8 : 0,
        backgroundColor: "black",
        pointerEvents: "none",
        transition: `opacity ${ExpansionTimeMS}ms ease-out`,
    }
}));

type InProgressProps = {
    sharedDisplay: boolean
}

export default function InProgress({sharedDisplay}:InProgressProps) {
    const {appState, user, sendMessage,userState} = useContext(EngageAppContext.current);
    const theme = useTheme<Theme>();
    const [panelState, setPanelState] = useState<PanelState>(PanelState.collapsed);

    const isLarge = useMediaQuery(theme.breakpoints.up("lg"));

    const showVirtualHost = (appState.common.gameOptions.streamUrl?.length ?? 0) > 1;
    const showPanel = (appState.common.gameOptions.showLeaderboard ?? false) || (appState.common.gameOptions.showChat ?? false);
    const streamURL = appState.common.gameOptions.streamUrl;

    const classes = useStyles({questionJustify: showVirtualHost ? "left" : "center", panelState});
    let content;
    if(appState.common.state === TriviaStatus.Complete) {
        content = <div className={classes.gameCompleteContainer}>
            {user?.role === Role.host ? <HostDashboard leaderboardRowCount={10} sharedDisplay={sharedDisplay}/> : null}
        </div>;
    } else {
        let aggregateResponses = appState.extra.aggregateResponses[appState.common.currentIndex];
        if(appState.common.state === TriviaStatus.QuestionSubmit && appState.host?.currentAggregation && !sharedDisplay) {
            aggregateResponses = appState.host.currentAggregation;
        }
        content = <div className={classes.questionContainer}>
            <Question question={appState.common.currentQuestion!} state={appState.common.state} role={user!.role}
                  currentHint={appState.common.currentHint} gameOptions={appState.common.gameOptions}
                  questionNumber={appState.common.currentIndex+1} totalQuestions={appState.common.totalQuestions}
                  sendMessage={sendMessage} aggregateResponses={aggregateResponses}
                  playerResponse={userState?.responses ? userState.responses[appState.common.currentIndex] : undefined}
                  playerScore={userState?.scores.individual ? userState.scores.individual[appState.common.currentIndex] : undefined}
                  showingHost={showVirtualHost}
            >
                {showVirtualHost && !isLarge ?
                <MobileVirtualHost embedURL={streamURL!} bottom={appState.common.currentQuestion?.inputType === InputType.Phrase}
                                   visible={appState.common.state === TriviaStatus.QuestionStart} /> : undefined}
            </Question>
        </div>;
    }

    return <div className={classes.inProgress}>
            <div className={classes.bottomContainer}>
                {
                    showVirtualHost && isLarge && appState.common.state && appState.common.state !== TriviaStatus.Complete ?
                        <div className={classes.virtualHostContainer}>
                            <VirtualHost connectorWidth={showPanel ? 30 : 170}
                                         embedURL={streamURL!}
                                         showThreeLine={true}
                                         hostName={appState.common.gameOptions.hostName}
                            />
                        </div>

                        : null
                }
                {content}
                {isLarge && <div className={classes.overlay}/> }
                {
                    showPanel && <AccessoryPanel panelState={panelState} setPanelState={setPanelState} sharedDisplay={sharedDisplay}/>
                }
            </div>
        </div>;
}